import { Alert, Stack } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { UserAccessStatePanel } from './UserAccessStatePanel';

export function UserAccessNoCustomersState({ header }: { header?: ReactNode }) {
  const { t } = useTranslation();

  return (
    <UserAccessStatePanel header={header}>
      <Stack p={2} spacing={2} alignItems="center" justifyContent="center" flex={1}>
        <Alert severity="info" role="status" sx={{ width: '100%' }}>
          {t('userAccessControl.empty.noCustomers')}
        </Alert>
      </Stack>
    </UserAccessStatePanel>
  );
}
